import { render, staticRenderFns } from "./versionChange.vue?vue&type=template&id=b065be7a&scoped=true&"
import script from "./versionChange.vue?vue&type=script&lang=js&"
export * from "./versionChange.vue?vue&type=script&lang=js&"
import style0 from "./versionChange.vue?vue&type=style&index=0&id=b065be7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b065be7a",
  null
  
)

export default component.exports